import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { UserBonus, WageringConditionBonus } from 'config/types/bonus/userBonus'
import Column from 'layout/Components/Column'
import { Trans } from 'react-i18next'
import { useCashbackBonus } from 'state/bonus/hooks/cashbackBonus'
import WagerProgressBar from '../../WagerProgressBar'
import WagerBonusMilestoneProgressBar from '../ActiveBonusContent/WageringBonusContent/WagerBonusMilestoneProgressBar'
import { BonusContentFieldTitle } from '../styled'

const BonusContentWager: React.FC<{ bonus: UserBonus; isShowMonochrome?: boolean } & BoxProps> = ({
  bonus,
  isShowMonochrome,
  ...props
}) => {
  const { activeBonus } = useCashbackBonus()

  return (
    bonus instanceof WageringConditionBonus &&
    !activeBonus && (
      <Column {...props}>
        <Flex alignItems="center">
          <BonusContentFieldTitle>
            <Trans>Wager</Trans> (x{bonus.wagerMultiplier})
          </BonusContentFieldTitle>
        </Flex>
        {bonus?.isActiveMilestone && (
          <WagerBonusMilestoneProgressBar bonus={bonus} isShowMonochrome={isShowMonochrome} />
        )}
        {!bonus?.isActiveMilestone && <WagerProgressBar bonus={bonus} mt="4px" isShowMonochrome={isShowMonochrome} />}
      </Column>
    )
  )
}

export default BonusContentWager
